import axios from 'axios';
import Api from '@/services/Api';
import '@/helpers/prototyped.js';

export const KanjiBlocksMixin = {
  methods: {
    async apiCall(inputKanji) {
      const code = ('0'+inputKanji.hexEncode()).slice(-5);
      const file = code+".svg";
      const svgObj =  Api().get("/repo/kanji?c="+inputKanji);
      
      return svgObj;
    },
    lines() {
      let grid = "<line x1='1' y1='1' x2='109' y2='1' style='stroke:#ddd;stroke-width:2' ></line>";
      grid+="<line x1='1' y1='1' x2='1' y2='109' style='stroke:#ddd;stroke-width:2' ></line>"
      grid+="<line x1='1' y1='109' x2='109' y2='109' style='stroke:#ddd;stroke-width:2' ></line>"
      grid+="<line x1='109' y1='1' x2='109' y2='109' style='stroke:#ddd;stroke-width:2' ></line>";
      grid+="<line x1='1' y1='54' x2='109' y2='54' style='stroke:#ddd;stroke-width:2;stroke-dasharray:3 3' ></line>";
      grid+="<line x1='55' y1='1' x2='55' y2='109' style='stroke:#ddd;stroke-width:2;stroke-dasharray:3 3' ></line>";
      return grid;
    },
    strokeBlocks(svg,target,type,opt) {
//      const code = ('0'+this.kanjiData.literal.hexEncode()).slice(-5);

      var parser = new DOMParser();
      var doc = parser.parseFromString(svg,"image/svg+xml");
      const total = doc.querySelectorAll("path").length;
      doc.querySelector("[id*='StrokeNumbers']").remove()
      const elems = [];
      var s = new XMLSerializer;
      var f,g,a,p,c1,c2;

      const grid = this.lines();

      for ( f = 0;f<total;f++) {
        doc.querySelector("svg").insertAdjacentHTML("afterbegin",grid);   
        if (typeof opt != "undefined" && typeof doc.querySelectorAll("svg")[f] != "undefined") {

          doc.querySelectorAll("svg")[f].setAttribute("width",opt.width);
          const height = opt.height || opt.width;
          doc.querySelectorAll("svg")[f].setAttribute("height",height);
        }     

        for (g = 0; g<total;g++) {
          a = doc.querySelectorAll("path")[g];
          if (g==f) {
            if (typeof type == "undefined" || type=="") {
              p = a.getAttribute("d").split(",");
              c1 = p[0].replace("M","");
              c2 = p[1].split(/c|C/).shift();
              a.insertAdjacentHTML("beforebegin","<circle id='"+(f+g)+"' cx='"+c1+"' cy='"+c2+"' r='5' stroke-width='0' fill='#FF2A00' opacity='0.7' />");
              
              a.style.visibility="visible";
              a.style.stroke="#black";  
            } else if (type == "grey") {
              a.style.visibility="visible";
              a.style.stroke="#aaaaaa";  
            }
          } else if (g<=f) {
            a.style.visibility="visible";
            a.style.stroke="#aaaaaa";
          } else {
            a.style.visibility="hidden";
          }
        }
        let finalSvg = doc.getElementsByTagName("svg")[0];
        //console.log(finalSvg);
        elems.push(s.serializeToString(finalSvg));
        
        if (doc.querySelector("svg circle")) {
          doc.querySelector("svg circle").remove();
        }
      }
      document.querySelector("#"+target).innerHTML=elems.join(""); 
    },
    strokesOnly(svg,target,opt) {
      let f,elems=[];
      var s = new XMLSerializer;
      var parser = new DOMParser();
      var doc = parser.parseFromString(svg,"image/svg+xml");
      doc.querySelector("[id*='StrokeNumbers']").remove()
      if (typeof opt != "undefined") {
        doc.querySelector("svg").setAttribute("width",opt.width);
        const height = opt.height || opt.width;
        doc.querySelector("svg").setAttribute("height",height);
      }     

      const total = doc.querySelectorAll("path").length;
      const grid = this.lines();
      for ( f = 0;f<opt.items;f++) {
        if (typeof opt != "undefined" && typeof doc.querySelectorAll("svg")[f] != "undefined") {
          doc.querySelectorAll("svg")[f].setAttribute("width",opt.width);
        }     

        doc.querySelector("svg").insertAdjacentHTML("afterbegin",grid);        
        doc.querySelectorAll("path").forEach(v=>{v.style.stroke="#dddddd"});
        let finalSvg = doc.getElementsByTagName("svg")[0];
        elems.push(s.serializeToString(finalSvg));
      }

      document.querySelector("#"+target).innerHTML=elems.join(""); 
    },
    gridOnly(target,opt) {
      let f,elems=[],svg;
      console.log("here");

      for(f=0;f<opt.items;f++) {
        var s = new XMLSerializer;
        var xmlns = "http://www.w3.org/2000/svg";
        svg = document.createElementNS(xmlns,"svg");
        const width = opt.width || 109;
        const height = opt.height || opt.width;
        svg.setAttributeNS(null,"width",width);
        svg.setAttributeNS(null,"height",height);
        svg.setAttributeNS(null,"viewbox","0 0 109 109")
        svg.innerHTML=this.lines();
        elems.push(s.serializeToString(svg));
        console.log(svg);
      }
      document.querySelector("#"+target).innerHTML=elems.join("");
    }   
  }
}